export default __webpack_public_path__ + "static/PromptIconSix-2d072b881bb03b8fdb9f560a8953d02e.png";